import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";

import validationUtils from "../../../../../utils/ValidationUtils";
import { SYNCHRONIZATIONS_VALIDATION_RULES } from "./synchronizationsValidationRules";
import { BILLING_PERIODS } from "../../../../../utils/data/models";
import * as dataActions from "../../../../../utils/data/dataActions";
import BillingPeriodField from "../reports/forms/BillingPeriodField";
import { TERMINATED } from "../../enums/clientStatusTypes";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FINANCE } from "../../../../../utils/Roles";

class SynchronizationsForm extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        const { clientId, dataActions } = this.props;
        dataActions.getDataList(
            BILLING_PERIODS,
            0,
            0,
            "",
            ["startDate:desc"],
            ["billingPeriods.clientId==" + clientId],
            {},
            {},
            "billingPeriodId,localizations,startDate,endDate"
        );
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(BILLING_PERIODS);
    }

    render() {
        const { billingPeriods, handleSubmit, clientStatusType } = this.props;
        const isTerminatedClient = clientStatusType === TERMINATED.value; /** Blocking sync button for all roles */
        const viewOnly = userHasAccess([FINANCE], true);

        return (
            <div>
                <form onSubmit={handleSubmit} className="standalone-form process-sync">
                    <BillingPeriodField
                        id="billingPeriodId"
                        name="billingPeriodId"
                        billingPeriods={billingPeriods}
                    />
                    <span>
                        <button
                            disabled={
                                this.props.disableSyncButton ||
                                isTerminatedClient ||
                                viewOnly
                            }
                            type="submit"
                            className="btn btn-lg btn-primary"
                        >
                            <FormattedMessage id="clients.client.processSync.form.synchronize" />
                        </button>
                    </span>
                </form>
            </div>
        );
    }
}

SynchronizationsForm.propTypes = {
    clientId: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func,
    billingPeriods: PropTypes.array,
    dataActions: PropTypes.object,
    disableSyncButton: PropTypes.bool,
    clientStatusType: PropTypes.string,
};

SynchronizationsForm.contextTypes = {
    intl: intlShape,
};

function mapStateToProps(state) {
    const billingPeriods = state.data.billingPeriods || {};
    const billingPeriodItems = billingPeriods.items || [];

    return {
        billingPeriods: billingPeriodItems,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: "synchronisationsForm",
        validate: (values) => validationUtils.validate(values, SYNCHRONIZATIONS_VALIDATION_RULES),
    })(SynchronizationsForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/synchronizations/SynchronizationsForm.js